// Action Types
export const PENDING = '_PENDING'
export const SUCCESS = '_SUCCESS'
export const FAILURE = '_FAILURE'

export const GET_ALL_TAGS = 'GET_ALL_TAGS'
export const ADD_NEW_TAG = 'ADD_NEW_TAG'
export const UPDATE_TAG_CATEGORY = 'UPDATE_TAG_CATEGORY'
export const UPDATE_TAG_NAME = 'UPDATE_TAG_NAME'
export const DELETE_TAG = 'DELETE_TAG'
export const UPDATE_TAG_CATEGORY_SEQUENCE = 'UPDATE_TAG_CATEGORY_SEQUENCE'
export const CREATE_TAG_CATEGORY = 'CREATE_TAG_CATEGORY'
export const UPDATE_TAG_CATEGORY_NAME = 'UPDATE_TAG_CATEGORY_NAME'
export const DELETE_TAG_CATEGORY = 'DELETE_TAG_CATEGORY'
export const BATCH_UPDATE_TAGS_AND_CATEGORIES = 'BATCH_UPDATE_TAGS_AND_CATEGORIES'
export const GET_TAG_MANAGER_EDIT_PERMISSIONS = 'GET_TAG_MANAGER_EDIT_PERMISSIONS'

export const initialState = {
  tags: [],
  isLoading: false,
  error: null,
  isPermissionLoading: false,
  userPermission: null
}

const tagManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_ALL_TAGS}${PENDING}`: {
      return {
        ...state,
        isLoading: true,
        error: null
      }
    }
    case `${GET_ALL_TAGS}${SUCCESS}`: {
      return {
        ...state,
        isLoading: false,
        tags: action.data.tags,
        error: null
      }
    }
    case `${GET_ALL_TAGS}${FAILURE}`: {
      return {
        ...state,
        isLoading: false,
        error: action.data.error
      }
    }

    case `${BATCH_UPDATE_TAGS_AND_CATEGORIES}${PENDING}`: {
      return {
        ...state,
        isLoading: true,
        isError: false
      }
    }
    case `${BATCH_UPDATE_TAGS_AND_CATEGORIES}${SUCCESS}`: {
      const {
        createdCategories: newlyCreatedCategories,
        createdTagValues: newlyCreatedTagValues,

        tagsToUpdate,
        tagsToDelete,
        categoriesToUpdate,
        categoriesToDelete,
        categorySequenceChanges
      } = action.data

      let clonedTags = _.cloneDeep(state.tags)

      // Add new Categories
      newlyCreatedCategories.forEach((newCategory) => {
        clonedTags.push({
          id: newCategory.id,
          name: newCategory.name,
          sequence: newCategory.sequence,
          values: newCategory.tagValues.map((tagValue) => ({
            id: tagValue.id,
            name: tagValue.name
          }))
        })
      })

      // Add new Tag Values to the existing categories
      Object.keys(newlyCreatedTagValues).forEach((key) => {
        const categoryId = parseInt(key)
        const newTagValue = newlyCreatedTagValues[categoryId]
        const categoryIndex = clonedTags.findIndex((cat) => cat.id === categoryId)

        if (categoryIndex !== -1) {
          newTagValue.forEach((tag) => {

            clonedTags[categoryIndex].values.push({
              id: tag.id,
              name: tag.name
            })
          })
        }
      })

      // Update Tag Names
      tagsToUpdate.forEach((tagToUpdate) => {
        clonedTags.forEach((category) => {
          const tagIndex = category.values.findIndex((tag) => tag.id === tagToUpdate.id)
          if (tagIndex !== -1) {
            category.values[tagIndex].name = tagToUpdate.name
          }
        })
      })

      // Delete Tags
      tagsToDelete.forEach((tagIdToDelete) => {
        clonedTags.forEach((category) => {
          category.values = category.values.filter((tag) => tag.id !== tagIdToDelete)
        })
      })

      // Update Category Names
      categoriesToUpdate.forEach((categoryToUpdate) => {
        const categoryIndex = clonedTags.findIndex((cat) => cat.id === categoryToUpdate.id)
        if (categoryIndex !== -1) {
          clonedTags[categoryIndex].name = categoryToUpdate.name
        }
      })

      // Delete Categories
      clonedTags = clonedTags.filter((cat) => !categoriesToDelete.includes(cat.id))

      // Update Category Sequences
      categorySequenceChanges.forEach((sequenceChange) => {
        const categoryIndex = clonedTags.findIndex((cat) => cat.id === sequenceChange.id)
        if (categoryIndex !== -1) {
          clonedTags[categoryIndex].sequence = sequenceChange.sequence
        }
      })

      return {
        ...state,
        isLoading: false,
        isError: false,
        tags: clonedTags
      }
    }
    case `${BATCH_UPDATE_TAGS_AND_CATEGORIES}${FAILURE}`: {
      console.error(action.data.error)

      return {
        ...state,
        isLoading: false,
        isError: true
      }
    }

    case `${GET_TAG_MANAGER_EDIT_PERMISSIONS}${PENDING}`: {
      return {
        ...state,
        isPermissionLoading: true,
        error: null
      }
    }
    case `${GET_TAG_MANAGER_EDIT_PERMISSIONS}${SUCCESS}`: {
      return {
        ...state,
        isPermissionLoading: false,
        userPermission: action.data.canEdit,
        error: null
      }
    }
    case `${GET_TAG_MANAGER_EDIT_PERMISSIONS}${FAILURE}`: {
      return {
        ...state,
        isPermissionLoading: false,
        userPermission: null,
        error: action.data.error
      }
    }
    default:
      return state
  }
}

export default tagManagerReducer
